import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import BestBabyFormulaLawyersWrapper from "@components/layouts/bestbabyformulalawyersWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function BestBabyFormulaLawyersHome(): ReactElement {
    return (
        <BestBabyFormulaLawyersWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <PrivacyPolicy
                    category="BabyFormula"
                    domain="BestBabyFormulaLawyers.com"
                />
            </div>
        </BestBabyFormulaLawyersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
